/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnswerApplicant
 */
export interface AnswerApplicant {
    /**
     * 
     * @type {number}
     * @memberof AnswerApplicant
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof AnswerApplicant
     */
    attempt: number;
    /**
     * 
     * @type {number}
     * @memberof AnswerApplicant
     */
    question: number;
    /**
     * 
     * @type {string}
     * @memberof AnswerApplicant
     */
    text: string;
    /**
     * 
     * @type {number}
     * @memberof AnswerApplicant
     */
    mcAnswer?: number | null;
}

/**
 * Check if a given object implements the AnswerApplicant interface.
 */
export function instanceOfAnswerApplicant(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "attempt" in value;
    isInstance = isInstance && "question" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function AnswerApplicantFromJSON(json: any): AnswerApplicant {
    return AnswerApplicantFromJSONTyped(json, false);
}

export function AnswerApplicantFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerApplicant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'attempt': json['attempt'],
        'question': json['question'],
        'text': json['text'],
        'mcAnswer': !exists(json, 'mc_answer') ? undefined : json['mc_answer'],
    };
}

export function AnswerApplicantToJSON(value?: AnswerApplicant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attempt': value.attempt,
        'question': value.question,
        'text': value.text,
        'mc_answer': value.mcAnswer,
    };
}

